import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './ItineraryCoverHeader.css';
import React from 'react';
import { get, getDictionaryItem, canUseDOM, getPageThemeColors, getColorByTheme } from '../../utils';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import CuratorPicks from '../atoms/CuratorPicks/CuratorPicks';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { fullWidthStyles } from '../57_HeaderFullWidth/headerFullWidth';
import { Text, RichText, Placeholder } from '@sitecore-jss/sitecore-jss-react';
import Video from '../atoms/Video';
import { headerImageStyle } from '../57_HeaderArticle1/HeaderArticle1';
import FavouriteBtn from '../atoms/FavouriteBtn/FavouriteBtn';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import DarkThemeControl from '../BrightcoveVideosAtoms/DarkThemeControl';
var videoWhiteOverlayTime = 750;
var videoFadeTime = 400;
export var ItineraryCoverHeader = function ItineraryCoverHeader(_ref) {
  var fields = _ref.fields,
    rendering = _ref.rendering,
    children = _ref.children,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var days = get(fields, 'data.item.days') || [];
  var moduleId = get(fields, 'data.item.id');
  var rawCurators = get(fields, 'data.item.curators.jss.value');
  var curators = rawCurators ? JSON.parse(rawCurators) : '';
  var dictionary = get(fields, 'data.dictionary');
  var CuratorsPick = getDictionaryItem(dictionary, 'CuratorsPick');
  //const pois = get(fields, 'data.item.pois.values') || [];
  var title = get(fields, 'data.item.title.jss');
  var introText = get(fields, 'data.item.introText.jss');
  var name = get(fields, 'data.item.name');
  var placeNumber = 0;
  var _fields$data = fields.data,
    addToFavAnalytics = _fields$data.addToFavAnalytics,
    smallBannerClickAnalytics = _fields$data.smallBannerClickAnalytics;
  days.map(function (item) {
    var length = get(item, 'pois.values.length');
    placeNumber += length;
  });
  placeNumber = placeNumber || get(fields, 'data.item.pois.values.length');
  var countDays = days.length;
  var hasCategory = Boolean(get(fields, 'data.item.category.targetItem.title.jss.value'));
  var category = get(fields, 'data.item.category.targetItem.title.jss');
  var hasIntroText = Boolean(introText);
  var hasTitle = Boolean(title);
  var BASE_URL = String(process.env.REACT_APP_MEDIA_HOST || '');
  var dictionaryValues = get(fields, 'data.dictionary.dictionaryValues');
  var dayPhrase = dictionaryValues ? get(dictionaryValues[2], 'phrase.jss.value') : '';
  var placesPhrase = dictionaryValues ? get(dictionaryValues[3], 'phrase.jss') : '';
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isVdsite = _React$useState2[0],
    setIsVdsite = _React$useState2[1];
  var darkMode = get(sitecoreContext, 'darkMode');
  var actions = get(sitecoreContext, 'actions', {});
  var _actions$changeThemeF = actions.changeThemeFunction,
    changeThemeFunction = _actions$changeThemeF === void 0 ? function () {} : _actions$changeThemeF;
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ActiveColorHex = get(params, 'ActiveColorHex');
  var ColorHex = get(params, 'ColorHex');
  var primaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  var primaryColorActive = primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active;
  var variables = BackgroundColorHex ? {
    '--m57-itinerary-cover-header-primary-color': BackgroundColorHex,
    '--m57-itinerary-cover-header-active-primary-color': ActiveColorHex,
    '--m57-itinerary-cover-header-color': ColorHex
  } : {
    '--m57-itinerary-cover-header-primary-color': primaryColor,
    '--m57-itinerary-cover-header-active-primary-color': primaryColorActive,
    '--m57-itinerary-cover-header-color': getColorByTheme(primaryPageThemeColor)
  };
  var renderMediaPlaceholder = function renderMediaPlaceholder() {
    return /*#__PURE__*/React.createElement(Placeholder, {
      name: "media-header-general",
      rendering: rendering,
      mediaDesc: introText.value
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, params && params['Dark Mode Switcher Show'] && /*#__PURE__*/React.createElement(DarkThemeControl, {
    handleClick: changeThemeFunction,
    label: "Dark Mode",
    value: darkMode,
    params: params
  }), /*#__PURE__*/React.createElement("div", {
    className: "container",
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group remove-padding-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    "data-animation-breakpoint": "768",
    className: "header-animation-breakpoint header__poi header__full-width-mob js-header-bm-parent"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-bb__wrapper header-bb__wrapper--poster-show"
  }, process.env.STORYBOOK_MODE ? children : renderMediaPlaceholder()), /*#__PURE__*/React.createElement("div", {
    className: "header-bb__info js-header-bm header-animation__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-animate__content-bg"
  }), /*#__PURE__*/React.createElement(CuratorPicks, {
    copy: CuratorsPick,
    curators: curators.curators,
    analytics: {
      smallBannerClickAnalytics: smallBannerClickAnalytics,
      params: params,
      name: name
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "header__type-tag"
  }, hasCategory && /*#__PURE__*/React.createElement(Text, {
    field: category
  })), hasTitle ? /*#__PURE__*/React.createElement("h1", {
    className: "header__info-title"
  }, /*#__PURE__*/React.createElement(Text, {
    field: title
  })) : '', /*#__PURE__*/React.createElement("div", {
    className: "header__icons"
  }, placeNumber > 0 && /*#__PURE__*/React.createElement("div", {
    className: "details-icon__image"
  }, /*#__PURE__*/React.createElement("p", {
    className: "details-text"
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "details-icon__img",
    width: "16.093",
    height: "19.71",
    viewBox: "0 0 16.093 19.71"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-76.508 -194.206)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57",
    transform: "translate(76.758 193.961)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 107",
    d: "M84.4,193.964a7.6,7.6,0,0,0-7.639,7.2v.038c.125,4.366,3.95,8.393,7.335,11.755a.754.754,0,0,0,1.062-.019c3.132-3.372,7.275-7.026,7.195-11.943v0a7.555,7.555,0,0,0-7.954-7.033Zm.026,1.3a6.155,6.155,0,0,1,6.509,5.763C91,205,87.67,208.253,84.617,211.492c-3.168-3.2-6.32-6.842-6.43-10.3a6.178,6.178,0,0,1,6.236-5.93Z",
    transform: "translate(-76.758 -193.466)",
    fill: "var(--m57-itinerary-cover-header-primary-color)",
    stroke: "var(--m57-itinerary-cover-header-primary-color)",
    "stroke-width": "0.5"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 78",
    cx: "2",
    cy: "2",
    r: "2",
    transform: "translate(6 6)",
    fill: "var(--m57-itinerary-cover-header-primary-color)"
  })))), placeNumber, " ", /*#__PURE__*/React.createElement(Text, {
    field: placesPhrase
  }))), countDays > 0 && /*#__PURE__*/React.createElement("div", {
    className: "details-icon__image"
  }, /*#__PURE__*/React.createElement("p", {
    className: "details-text"
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "details-icon__img",
    width: "17.72",
    height: "17.721",
    viewBox: "0 0 17.72 17.721"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-21 -21)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 64",
    transform: "translate(21 21)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 115",
    d: "M29.86,973.362a8.86,8.86,0,1,0,8.86,8.86A8.874,8.874,0,0,0,29.86,973.362Zm0,1.833a7.027,7.027,0,1,1-7.027,7.027A7.013,7.013,0,0,1,29.86,975.2Zm0,1.528a.917.917,0,0,0-.917.917v4.583a.915.915,0,0,0,.458.792L32.839,985a.915.915,0,0,0,.917-1.585L30.777,981.7V977.64A.917.917,0,0,0,29.86,976.723Z",
    transform: "translate(-21 -973.362)",
    fill: "var(--m57-itinerary-cover-header-primary-color)"
  })))), dayPhrase && countDays > 0 && dayPhrase.replace('{day}', countDays)))), /*#__PURE__*/React.createElement("div", {
    className: "header__content-p"
  }, hasIntroText && /*#__PURE__*/React.createElement(RichText, {
    field: introText
  })), /*#__PURE__*/React.createElement(FavouriteBtn, {
    itemId: moduleId,
    classes: 'my-icon-white header__fav-btn',
    componentPrimaryColor: BackgroundColorHex,
    componentPrimaryColorActive: ActiveColorHex,
    analyticsClick: function analyticsClick(action) {
      return tealiumClickFunc(tealiumMergeClickData(addToFavAnalytics, params), "".concat(action, " : ").concat(name));
    }
  })))))))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: "header-animation ".concat(commonStyles, " ").concat(fullWidthStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(headerImageStyle)
  }, children);
};
var commonStyles = "ceqehn";
var ltrStyles = "l1trs4xa";
var rtlStyles = "r1ohf2g6";
export default ItineraryCoverHeader;